/**
 * The design tokens, as constants. Values come from current_webapp_vue/CLAUDE.md
 * (spacing and type scales, card radius, faces) and src/core/plugins/vuetify.js
 * (the palette). tokens.css holds the same values as `--scvc-*` custom
 * properties; tokens.test.ts fails if the two ever disagree.
 *
 * Vuetify reads this file. Tailwind reads tokens.css. Both render the same product.
 */
export const tokens = {
  color: {
    primary: '#0066cc',
    onPrimary: '#ffffff',
    secondary: '#00a3ff',
    accent: '#0052a3',
    background: '#fafbfc',
    surface: '#ffffff',
    error: '#dc3545',
    warning: '#ffc107',
    text: '#333333',
    textMuted: '#666666',
    border: '#e0e0e0',
  },
  radius: {
    card: '12px',
    control: '4px',
  },
  space: {
    s1: '4px',
    s2: '8px',
    s3: '12px',
    s4: '16px',
    s6: '24px',
    s8: '32px',
    s12: '48px',
    s16: '64px',
  },
  text: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    md: '18px',
    lg: '20px',
    xl: '24px',
    xxl: '30px',
    xxxl: '36px',
    display: '48px',
  },
  font: {
    sans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    serif: "'Noto Serif', Georgia, serif",
  },
} as const

/** `--scvc-color-text-muted` for ('color', 'textMuted'). */
export function cssVariableName(group: string, key: string): string {
  const kebab = key.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`).replace(/^s(\d+)$/, '$1')
  return `--scvc-${group}-${kebab}`
}
